import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { utils } from "../../utils";
import httpService from "../../services/httpService";

export const initialState = {
	auth: {
		token: "",
	},
	loading: false,
	apiSuccess: false,
	apiError: false,
	logged: false,
};

const logInSlice = createSlice({
	name: "logIn",
	initialState,
	reducers: {
		setAuthFromApi: (state, action: PayloadAction<string>) => {
			httpService.setAuthToken(action.payload);
			state.auth.token = action.payload;
			state.loading = false;
			state.apiSuccess = true;
			state.apiError = false;
			state.logged = true;
		},
		resetAuthState: (state) => {
			httpService.setAuthToken("");
			state.auth.token = "";
			state.loading = false;
			state.apiSuccess = true;
			state.apiError = false;
			state.logged = false;
		},
		setAuthLoading: (state) => {
			state.loading = true;
			state.apiSuccess = false;
			state.apiError = false;
			state.logged = false;
		},
		setAuthApiError: (state) => {
			state.auth = initialState.auth;
			state.loading = false;
			state.apiError = true;
			state.apiSuccess = false;
			state.logged = false;
		},
	},
});

export const { setAuthFromApi, resetAuthState, setAuthLoading, setAuthApiError } = logInSlice.actions;

export const getAuthToken = (state: RootState) => state.authReducer.auth.token;
export const isLogged = (state: RootState) => state.authReducer.logged;

export default logInSlice.reducer;
